import { Result } from '@blade/std-lib'
import {
  fetchUserPositionsRequestAction,
  positionsRegistry,
} from '@root/entities/position'
import { reatomPaginated } from '@root/shared/lib'

import type { Network } from '@root/entities/network'
import type { WalletId } from '@root/entities/wallet'

// TODO: Mobile pagination

export const reatomUserPositions = ({
  network,
  walletId,
}: {
  network: Network.Network
  walletId: WalletId | undefined
}) => {
  const stateAtom = reatomPaginated({
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: `reatomUserPositionsPairs.${network}`,
    limit: 100,
    loadItems: async (ctx, { limit, offset }) => {
      const result = await fetchUserPositionsRequestAction(ctx, {
        network,
        limit,
        offset,
        walletIds: walletId ? [walletId] : [],
      })

      return result.pipe(
        Result.map((it) =>
          it.data.map((dto) => positionsRegistry.resolveFromDto(ctx, dto)),
        ),
      )
    },
  })

  return stateAtom
}
